import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet } from "../utils/api_service";
const initialState = {
    entityMaster: [],
};
let URL = endpoints.entityMaster;
const entityMasterSlice = createSlice({
    name: "entityMaster",
    initialState,
    reducers: {
        entityMasterSuccess: (state = cloneDeep(initialState), action) => {
            const { row } = action.payload;
            return {
                ...state,
                entityMaster: row,
            };
        },

        resetState: (state = cloneDeep(initialState), action) => {
            return {
                ...state,
                ...initialState,
            };
        },
    },
});

export const { entityMasterSuccess, resetState } = entityMasterSlice.actions;

export default entityMasterSlice.reducer;

export const getEntityMaster = () => async (dispatch) => {
    try {
        const response = apiGet({
            url: URL,
        }).then(({ data, success }) => {
            if (success) {
                const { content } = data.data;
                const row = content.map((entityMasterData, index) => {
                    let entityMaster = {
                        index: index + 1,
                        id: entityMasterData.id === null ? "" : entityMasterData.id,
                        name: entityMasterData.name === null ? "" : entityMasterData.name,
                        api: entityMasterData.api === null ? "" : entityMasterData.api,
                        indexValue: entityMasterData.indexValue === null ? "" : entityMasterData.indexValue,
                        extra1: entityMasterData.extra1 === null ? "" : entityMasterData.extra1,
                        extra2: entityMasterData.extra2 === null ? "" : entityMasterData.extra2,
                    };
                    return entityMaster;
                });
                dispatch(entityMasterSuccess({ row }));
                return { response: row, success };
            }
            return { response: [], success };
        });
        return response;
    } catch (e) {
        return { response: [], success: false };

    }
};
